// Routes de l'espace de supervision (lot L6-A, M24), raccordées dans Application.tsx à la place de l'attente.
import type { RouteObject } from 'react-router';
import { PageCompetences } from './PageCompetences';
import { PageDeploiement } from './PageDeploiement';
import { PageExports } from './PageExports';
import { PageIndicateurs } from './PageIndicateurs';
import { PageRepertoire } from './PageRepertoire';

export const routesSupervision: RouteObject[] = [
  { path: '/supervision', element: <PageRepertoire /> },
  { path: '/supervision/deploiement', element: <PageDeploiement /> },
  { path: '/supervision/indicateurs', element: <PageIndicateurs /> },
  { path: '/supervision/competences', element: <PageCompetences /> },
  { path: '/supervision/exports', element: <PageExports /> },
];
